import config from "@sg-protect/runtime-config";
import createFetchClient from "openapi-fetch";
import createQueryClient from "openapi-react-query";
import { redirectOnForbidden, redirectOnStatusCode } from "@sg-protect/core";
import { setMsalManagementTokenMiddleware } from "./middlewares/setMsalToken.ts";
import type { AuthorizationFailureReasons, paths } from "./types.ts";

const WIZARD_PAGE_URL = "/archives/auth?onConnectedRedirectUri=%2Farchives";

export const client = createFetchClient<paths>({
    baseUrl: config.get().archives.api,
    credentials: "include"
});

client.use(
    redirectOnStatusCode({
        status: 401,
        to: () => `${config.get().archives.login}?returnUrl=${encodeURIComponent(window.location.href)}`
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "MissingShareGateLicense",
        to: WIZARD_PAGE_URL
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "InvalidMsalToken",
        to: WIZARD_PAGE_URL
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "MissingMsalUserRole",
        to: WIZARD_PAGE_URL
    })
);

if (process.env.APP_ENV !== "msw") {
    client.use(
        setMsalManagementTokenMiddleware({
            headerName: "ArchiveJwt"
        })
    );
}

const { queryOptions, useMutation, useQuery, useSuspenseQuery } = createQueryClient(client);

export { useSuspenseQuery };

export { queryOptions };

/**
 * @knipignore We want to export this even if they are not consumed yet.
 */
export { useMutation, useQuery };
